import { render, staticRenderFns } from "./contactdocument-add-or-update.vue?vue&type=template&id=14f0e56c&scoped=true&"
import script from "./contactdocument-add-or-update.vue?vue&type=script&lang=js&"
export * from "./contactdocument-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./contactdocument-add-or-update.vue?vue&type=style&index=0&id=14f0e56c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f0e56c",
  null
  
)

export default component.exports